import { render } from "./UserRecordsPage.vue?vue&type=template&id=db959c72&scoped=true"
import script from "./UserRecordsPage.vue?vue&type=script&lang=js"
export * from "./UserRecordsPage.vue?vue&type=script&lang=js"

import "./UserRecordsPage.vue?vue&type=style&index=0&id=db959c72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db959c72"]])

export default __exports__